import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Button from '../../../components/common/Button';
import { logoutConfirm, logoutReject } from '../../../modules/auth/actions';

const mapDispatchToProps = {
  confirm: logoutConfirm,
  reject: logoutReject
};

const LogoutAnonymousUserConfirm = ({ confirm, reject }) => (
  <div className="modal">
    <div>
      <h2 className="modal__header">Are you sure? All slips will be removed</h2>
      <div className="modal__button-line">
        <Button className="modal__button" onClick={confirm}>Yes</Button>
        <Button className="modal__button" onClick={reject}>No</Button>
      </div>
    </div>
  </div>
);

LogoutAnonymousUserConfirm.propTypes = {
  confirm: PropTypes.func.isRequired,
  reject: PropTypes.func.isRequired
};

export default connect(null, mapDispatchToProps)(LogoutAnonymousUserConfirm);
